import { Box, Divider, Paper, Typography } from "@mui/material";
import { useAuth } from "../context/Auth.context";
import { forwardRef, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import QRCode from "react-qr-code";
import { appUrl, capitalizeFirstLetter } from "./Utils";
import { QRPageStyle } from "./Styles.utils";

const QRCodeUtils = ({
  UserUrl = "",
  dealershipLogo = "",
  employeeName = "",
}) => {
  const auth = useAuth();
  let url;
  let printRef = useRef();
  useReactToPrint({
    content: () => printRef.current,
    pageStyle: QRPageStyle,
  });
  const getWorkFlowDetails = auth?.user?.associateDetails?.filter((data) => {
    return data?.dealership_id === auth?.user?.dealership_id;
  });

  console.log("getWorkFlowDetails", getWorkFlowDetails);
  if (!UserUrl) {
    url = `${appUrl}/getUserDetails/${auth.user.user_id}/${auth.user.dealership_id}/${getWorkFlowDetails[0]?.verification_workflow_id}`;
  }
  return (
    <>
      <Box ref={printRef}>
        <Paper
          sx={{
            background: "white",
            padding: "16px",
            display: { xs: "contents", sm: "flex" },
            justifyContent: "center",
            boxShadow: "none",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              background: "white",
              padding: "16px",
              display: { xs: "contents", sm: "flex" },
              justifyContent: "center",
              boxShadow: "none",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                mt: 5,
              }}
            >
              <Box>
                <img
                  src={dealershipLogo || auth.user.dealership_logo || ""}
                  width={110}
                  height={110}
                  alt="logo"
                  style={{ objectFit: "contain" }}
                />
              </Box>

              <Typography variant="h4" fontFamily={"sans-serif"} ml={5}>
                {employeeName
                  ? employeeName
                  : ` ${
                      capitalizeFirstLetter(auth.user.first_name) +
                      " " +
                      capitalizeFirstLetter(auth.user.last_name)
                    }`}{" "}
                Verification
              </Typography>
            </Box>
            <Divider sx={{ mt: "30px" }} />
            <Box
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"space-between"}
              mt={"25px"}
            >
              <Box>
                <Typography variant="h4" marginTop={"5px"}>
                  Why DeliveryIQ+ ?
                </Typography>
                <ol
                  style={{
                    listStyleType: "disc",
                    marginLeft: "2px",
                    fontSize: "25px",
                  }}
                >
                  <li>The lender requires verification</li>
                  <li>The state requires verification</li>
                  <li>We want to protect your interests</li>
                  <li>We want to save you 15 minutes</li>
                </ol>
              </Box>
              <Box mr={"25px"}>
                <Typography variant="h4">How to DeliveryIQ+ ? </Typography>
                <ol
                  style={{
                    listStyleType: "disc",
                    marginLeft: "2px",
                    fontSize: "25px",
                  }}
                >
                  <li>Scan the QR code</li>
                  <li>Enter your information</li>
                  <li>Watch the magic happen</li>
                </ol>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                borderRadius: "6px",
                alignItems: "center",
                mt: 5,
              }}
            >
              <QRCode value={UserUrl || url} size={300} />
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default QRCodeUtils;
